import React, { forwardRef, ChangeEvent, KeyboardEventHandler } from "react";
interface InputProps {
  name: string;
  label?: string;
  isRequired?: boolean;
  value?: string;
  checked?: boolean;
  isDisabled?: boolean;
  customClass?: string;
  placeholder?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onClick?: () => void;
  onPaste?: () => void;
  refs?: () => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  validate?: ({ name, value }: { name: string; value: string }) => ChangeEvent<HTMLInputElement>;
  autoComplete?: string;
  id?: string;
  shouldAutoFocus?: boolean;
  type?: string;
  error?: string;
  IsError?: boolean;
  readOnly?: boolean;
  tabIndex?: number;
  onKeyPress?: KeyboardEventHandler<HTMLInputElement>;
  inputClass?: string;
  testId?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name = "text-input",
      label,
      isRequired,
      value,
      checked = false,
      isDisabled,
      customClass,
      onChange = null,
      onFocus = null,
      onBlur = null,
      onClick = null,
      onPaste = null,
      placeholder,
      validate = (e) => e,
      refs = () => "",
      autoComplete = "on",
      id,
      shouldAutoFocus,
      type = "text",
      error,
      IsError,
      readOnly,
      tabIndex,
      onKeyPress,
      testId,
      labelNameClass,
      prefix = null,
      suffix = null,
    },
    ref
  ) => {
    return (
      <>
        <span className={labelNameClass}>{label}</span>
        {prefix}
        <input
          required={isRequired}
          disabled={isDisabled}
          placeholder={placeholder}
          className={customClass}
          value={value}
          type={type}
          name={name}
          checked={checked}
          id={id}
          ref={ref || ((input) => refs(input))}
          readOnly={readOnly}
          autoFocus={shouldAutoFocus}
          tabIndex={tabIndex}
          autoComplete={autoComplete}
          onChange={(e) => onChange(validate({ name: e.target.name, value: e.target.value }))}
          onClick={onClick}
          onFocus={onFocus}
          onBlur={onBlur}
          onPaste={onPaste}
          onKeyPress={onKeyPress}
          data-testid={testId}
        />
        {suffix}
        {IsError && <span> {error} </span>}
      </>
    );
  }
);

export default Input;
